import useSWR from 'swr';
import { useMemo } from 'react';
import axios, { fetcher, endpoints } from 'src/utils/axios';
import { IUser } from 'src/types/user';


export function useGetUser() {
  const URL = endpoints.user.show
  const { data, error, isValidating } = useSWR(URL, fetcher);

  return {
    user: data?.user || null,
    isLoading: !error && !data,
    userError: error,
    isValidating,
  };
}

export async function updateUser(data: any) {
  const URL = endpoints.user.update
  console.log(data)
  try {
    const response = await axios.patch(URL, data);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
}

export async function resendConfirmationEmail() {
  const URL = endpoints.user.resend_confirmation;
  try {
    const response = await axios.post(URL);
    return response.data;
  } catch (error) {
    console.error('Error resending confirmation email:', error);
    throw error;
  }
}

export function useUpdatePassword() {
  const updatePassword = async (currentPassword:string, newPassword:string, newPasswordConfirmation:string) => {
    const URL =  endpoints.user.update_password;
    try {
      const response = await axios.patch(URL, {
        current_password: currentPassword,
        password: newPassword,
        password_confirmation: newPasswordConfirmation
      });
      return response.data;
    } catch (error) {
      console.error('Error updating password:', error);
      throw error;
    }
  };

  return { updatePassword };
}


export function useCancelSubscription() {
  const cancelSubscription = async (cancelReason: string, cancelDescription: string) => {
    const URL = endpoints.user.cancel_plan;
    try {
      const response = await axios.patch(URL, {
        subscription: {
          cancel_reason: cancelReason,
          cancel_description: cancelDescription
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      throw error;
    }
  };

  return { cancelSubscription };
}

export function useValidateInvitationAndSetPassword() {
  const validateInvitationAndSetPassword = async (
    invitationToken: string,
    password: string,
    passwordConfirmation: string
  ) => {
    const URL = endpoints.invitations.validate;
    try {
      const response = await axios.post(URL, {
        invitation_token: invitationToken,
        password,
        password_confirmation: passwordConfirmation
      });
      return response.data;
    } catch (error) {
      console.error('Error validating invitation and setting password:', error);
      throw error;
    }
  };
  return { validateInvitationAndSetPassword };
}

export function useValidateConfirmationAndSetPassword() {
  const validateConfirmationAndSetPassword = async (
    confirmationToken: string,
    password: string,
    passwordConfirmation: string
  ) => {
    const URL = endpoints.confirmations.confirm;
    try {
      const response = await axios.post(URL, {
        confirmation_token: confirmationToken,
        password,
        password_confirmation: passwordConfirmation
      });
      console.log(response)
      return response;
    } catch (error) {
      console.error('Error validating invitation and setting password:', error);
      throw error;
    }
  };
  return { validateConfirmationAndSetPassword };
}

export function useValidateConfirmation() {
  const validateConfirmation = async (confirmationToken: string) => {
    const URL = endpoints.confirmations.confirm;
    try {
      const response = await axios.post(URL, {
        confirmation_token: confirmationToken
      });
      return response;
    } catch (error) {
      console.error('Error validating confirmation:', error);
      throw error;
    }
  };

  return { validateConfirmation };
}

export function useRequestPasswordReset() {
  const requestPasswordReset = async (email: string) => {
    const URL = endpoints.reset_password.reset;
    try {
      const response = await axios.post(URL, {
        email
      });
      console.log(response);
      return response;
    } catch (error) {
      console.error('Error requesting password reset:', error);
      throw error;
    }
  };
  return { requestPasswordReset };
}

export function useResetPassword() {
  const resetPassword = async (reset_password_token: string, password: string, password_confirmation: string) => {
    const URL = endpoints.reset_password.set_password;
    try {
      const response = await axios.post(URL, {
        reset_password_token,
        password,
        password_confirmation
      });
      console.log(response);
      return response;
    } catch (error) {
      console.error('Error requesting password reset:', error);
      throw error;
    }
  };
  return { resetPassword };
}



